module.exports = __webpack_public_path__ + "static/media/TransUnion.f0b577a1.png";